function isInteger(value) {
    return Number.isInteger(value);
}

export { isInteger };
